import React, { useRef, useEffect, useState } from 'react'

import { Image } from '../../components/Image/Image'
import { Button } from '../../components/Button/Button'
import { GameWrapper } from '../../components/GameWrapper/GameWrapper'

import styles from './GameLabyrinth.module.scss'
import labyrinthImg from './labyrinth.png'
import confusedBarsImg from './confused-bars.png'
import arrowLeftImg from './arrow-left.png'
import arrowUpImg from './arrow-up.png'
import arrowRightImg from './arrow-right.png'
import arrowDownImg from './arrow-down.png'


const LABYRINTH = [
    [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 2, 2, 0],
    [3, 0, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 0, 1, 1, 2, 0],
    [2, 1, 1, 3, 0, 1, 2, 2, 2, 2, 2, 0, 1, 3, 1, 1, 0],
    [2, 2, 3, 2, 2, 1, 1, 2, 2, 2, 2, 1, 3, 2, 2, 1, 1],
    [1, 2, 2, 2, 2, 2, 3, 2, 2, 2, 2, 2, 2, 2, 2, 2, 1],
    [1, 1, 2, 2, 2, 0, 2, 2, 2, 2, 2, 2, 2, 2, 0, 0, 1],
    [1, 1, 3, 2, 0, 1, 1, 2, 2, 2, 2, 2, 2, 0, 1, 1, 1],
    [1, 3, 2, 2, 2, 1, 1, 1, 2, 2, 2, 2, 2, 1, 1, 1, 1],
    [3, 2, 2, 2, 2, 2, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1],
    [2, 2, 2, 2, 2, 2, 2, 1, 1, 2, 0, 2, 0, 1, 2, 1, 1],
    [2, 0, 1, 3, 2, 2, 2, 2, 3, 1, 3, 1, 3, 3, 2, 2, 1],
]
const yStep = 100 / LABYRINTH.length
const xStep = 100 / LABYRINTH[0].length

function GameLabyrinth() {
    const position = useRef({ x: 0, y: 9 })
    const [, updatePosition] = useState(null)
    const [win, setWin] = useState(false)

    useEffect(() => {
        if (!win) {
            window.document.addEventListener('keydown', keyHandler)
        }

        return () => {
            window.document.removeEventListener('keydown', keyHandler)
        }

        function keyHandler(ev) {
            switch (ev.keyCode) {
                case 37:
                    position.current = doStep(position.current, 'left')
                    updatePosition(position.current)
                    break
                case 38:
                    position.current = doStep(position.current, 'up')
                    updatePosition(position.current)
                    break
                case 39:
                    position.current = doStep(position.current, 'right')
                    updatePosition(position.current)
                    break
                case 40:
                    position.current = doStep(position.current, 'down')
                    updatePosition(position.current)
                    break
                default:
            }
        }
    }, [win, updatePosition])

    const positionCoordinates = position.current
    useEffect(() => {
        if (positionCoordinates.x === 16 && positionCoordinates.y === 1) {
            setWin(true)
        }
    }, [positionCoordinates, setWin])

    function keyHandler(side) {
        position.current = doStep(position.current, side)
        updatePosition(position.current)
    }

    return (
        <GameWrapper win={win}>
            <Image src={labyrinthImg} className={styles.bg} />
            <div className={styles.field}>
                <Image
                    src={confusedBarsImg}
                    className={styles.barsik}
                    style={{
                        left: `${xStep * position.current.x}%`,
                        top: `${yStep * position.current.y}%`,
                    }}
                />
            </div>
            {
                win
                    ? null
                    : (
                        <div className={styles.buttonsWrapper}>
                            <div className={styles.part} />
                            <Button src={arrowUpImg} className={styles.part} muted onClick={() => { keyHandler('up') }} />
                            <div className={styles.part} />

                            <Button src={arrowLeftImg} className={styles.part} muted onClick={() => { keyHandler('left') }} />
                            <Button src={arrowDownImg} className={styles.part} muted onClick={() => { keyHandler('down') }} />
                            <Button src={arrowRightImg} className={styles.part} muted onClick={() => { keyHandler('right') }} />
                        </div>
                    )
            }
        </GameWrapper>
    )
}

function doStep(position, side) {
    const { x, y } = position

    switch (side) {
        case 'left':
            // eslint-disable-next-line no-bitwise
            if (x > 0 && LABYRINTH[y][x - 1] & 2) {
                return { x: x - 1, y }
            }
            break
        case 'up':
            // eslint-disable-next-line no-bitwise
            if (LABYRINTH[y][x] & 1) {
                return { x, y: y - 1 }
            }
            break
        case 'right':
            // eslint-disable-next-line no-bitwise
            if (LABYRINTH[y][x] & 2) {
                return { x: x + 1, y }
            }
            break
        case 'down':
            // eslint-disable-next-line no-bitwise
            if (y < LABYRINTH.length - 1 && LABYRINTH[y + 1][x] & 1) {
                return { x, y: y + 1 }
            }
            break
        default:
    }

    return position
}

GameLabyrinth.propTypes = {}

export { GameLabyrinth }
